import { getFiscalRepSubscriptionStatusInfo } from './fiscal-rep-order';
import { getNifOrderStatusInfo } from './nif-order';
import { OrderRowFragment, OrderRowWithInfo } from './types';

export function getOrderRowWithInfo(order: OrderRowFragment): OrderRowWithInfo {
  switch (order.__typename) {
    case 'NifOrder':
      return {
        row: order,
        info: getNifOrderStatusInfo(order),
      };
    case 'FiscalRepSubscription':
      return {
        row: order,
        info: getFiscalRepSubscriptionStatusInfo(order),
      };
    default:
      throw new Error('Unknown order type');
  }
}
